/* KI-Badge fuer Section- und Hero-Bilder (EU AI Act Art. 50)
   Haengt ein sichtbares Badge an jedes <img>, dessen Alt-Text den Marker
   [KI] oder [KI-bearbeitet] enthaelt, und entfernt den Marker aus dem Alt-Text.
   Produktbilder werden serverseitig ueber snippets/ki-badge.liquid gerendert. */
(function () {
  var ANCHORS = [
    '.slideshow__bg',
    '.slideshow__slide-bg',
    '.product__media-container',
    '.product-card__image-wrapper',
    '.media-wrapper',
    '.media'
  ].join(',');

  function labelFor(alt) {
    if (alt.indexOf('[KI-bearbeitet]') !== -1) return 'Mit KI bearbeitet';
    if (alt.indexOf('[KI]') !== -1) return 'KI-generiert';
    return null;
  }

  function cleanAlt(alt) {
    var out = alt.split('[KI-bearbeitet]').join(' ').split('[KI]').join(' ');
    while (out.indexOf('  ') !== -1) {
      out = out.split('  ').join(' ');
    }
    return out.trim();
  }

  function buildBadge(text) {
    var el = document.createElement('span');
    el.className = 'ki-badge ki-badge--bottom-left ki-badge--md ki-badge--light';
    el.setAttribute('data-ki-badge', '');
    var svg = '<svg class="ki-badge__icon" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">'
      + '<path d="M8 1.4l1.35 3.25L12.6 6 9.35 7.35 8 10.6 6.65 7.35 3.4 6l3.25-1.35L8 1.4z" fill="currentColor"/>'
      + '<path d="M12.55 10.1l.62 1.48 1.48.62-1.48.62-.62 1.48-.62-1.48-1.48-.62 1.48-.62.62-1.48z" fill="currentColor" opacity=".55"/>'
      + '</svg><span class="ki-badge__text"></span>';
    el.innerHTML = svg;
    el.querySelector('.ki-badge__text').textContent = text;
    return el;
  }

  function anchorFor(img) {
    var el = img.parentElement;
    var depth = 0;
    while (el && depth < 7) {
      if (el.matches && el.matches(ANCHORS)) return el;
      el = el.parentElement;
      depth++;
    }
    return img.parentElement;
  }

  function run(root) {
    var scope = root || document;
    var imgs = scope.querySelectorAll('img[alt*="[KI"]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var text = labelFor(img.alt || '');
      if (!text) continue;

      img.alt = cleanAlt(img.alt);

      var host = anchorFor(img);
      if (!host) continue;
      if (host.querySelector('[data-ki-badge]')) continue;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(buildBadge(text));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('shopify:block:select', function (e) { run(e.target); });
})();